import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/prueba-terminada",
  "alias": [],
  "documento": "raiz",
  "acceso": "autenticado",
  "filas": [
    "159"
  ],
  "cita": "Controllers/PruebaController.cs"
} satisfies RutaProd;
